const MENSAJE_GENERICO =
    "Se produjo un error inesperado en el servidor. Inténtelo de nuevo y, si persiste, avise al administrador.";

const MENSAJE_SIN_RESPUESTA =
    "No se pudo contactar con el servidor. Compruebe su conexión e inténtelo de nuevo.";

const PATRONES_VOLCADO = [
    /^[\w.]+(Exception|Error)[:\s]/, // "System.InvalidOperationException: ..."
    /\n\s+(at|en) \S+\(/,            // líneas de pila
    /\nHEADERS\n=+/                  // página de error de desarrollo de ASP.NET
];

/**
 * Un volcado de excepción no es un mensaje: no cabe en un toast ni le dice nada al usuario
 */
const esVolcadoDeExcepcion = texto => PATRONES_VOLCADO.some(patron => patron.test(texto));

const extraerMensaje = error => {
    if (error.response && error.response.data) {
        if (typeof error.response.data === "string") return error.response.data;
        if (error.response.data.message) return error.response.data.message;
    }
    return error.message || error.toString();
};


const noHuboRespuesta = error => Boolean(error && error.request && !error.response);

/**
 * Mensaje que el backend quiso mostrar al usuario, o uno propio cuando no hay ninguno que mostrar
 */
export const getErrorMessage = error => {
    if (noHuboRespuesta(error)) return MENSAJE_SIN_RESPUESTA;

    const mensaje = extraerMensaje(error);
    return typeof mensaje === "string" && esVolcadoDeExcepcion(mensaje)
        ? MENSAJE_GENERICO
        : mensaje;
};
